import styled from 'styled-components';

import Image from '../../Image';

export const CtaContainer = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-basis: 72px;

  &:hover,
  &:focus {
    span {
      text-decoration: underline;
    }
  }
`;

export const CtaIcon = styled(Image)`
  width: 3rem;
  height: 3rem;
`;

export const SocialMediaLink = styled.span`
  font-size: 0.875rem;
`;
